var _regeneratorRuntime = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _asyncToGenerator = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _classCallCheck = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _require = require('factom'),
    WalletdCli = _require.WalletdCli;

var _require2 = require('./key-helpers'),
    isValidIdentityKey = _require2.isValidIdentityKey,
    isValidSecretIdentityKey = _require2.isValidSecretIdentityKey,
    getPublicIdentityKey = _require2.getPublicIdentityKey;
/**
 * Helper class to user factom-walletd as a key store.
 * @memberof app
 * @param {Object} [opts] - Options of connection to factom-walletd. See {@link https://factomjs.luciap.ca/#connectionoptions}.
 * @example
 * const store = new FactomWalletdKeyStore({
 *          host: 'localhost',
 *          user: 'paul',
 *          password: 'pass'
 * });
 */


var FactomWalletdKeyStore =
/*#__PURE__*/
function () {
  "use strict";

  function FactomWalletdKeyStore(opts) {
    _classCallCheck(this, FactomWalletdKeyStore);

    this.cli = new WalletdCli(opts);
  }
  /**
   * Fetch corresponding identity key from the wallet if necessary.
   * @async
   * @param {string} idKey - Identity key.
   * @returns {string} - Corresponsing secret identity key.
   */


  _createClass(FactomWalletdKeyStore, [{
    key: "getSecretIdentityKey",
    value: function () {
      var _getSecretIdentityKey = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(idKey) {
        var _ref, secret;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (isValidIdentityKey(idKey)) {
                  _context.next = 2;
                  break;
                }

                throw new Error("".concat(idKey, " is not a valid identity key."));

              case 2:
                if (!(idKey[2] === 's')) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", idKey);

              case 6:
                _context.next = 8;
                return this.cli.call('identity-key', {
                  public: idKey
                });

              case 8:
                _ref = _context.sent;
                secret = _ref.secret;
                return _context.abrupt("return", secret);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getSecretIdentityKey(_x) {
        return _getSecretIdentityKey.apply(this, arguments);
      }

      return getSecretIdentityKey;
    }()
    /**
     * Import keys in walletd.
     * @async
     * @param {string|string[]} secretIdKeys - A single secret key or an array of secret keys to import.
     * @returns {{public: string, secret: string}[]}
     */

  }, {
    key: "importIdentityKeys",
    value: function () {
      var _importIdentityKeys = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(secretIdKeys) {
        var params, _ref2, keys;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!Array.isArray(secretIdKeys)) {
                  _context2.next = 6;
                  break;
                }

                if (secretIdKeys.every(function (k) {
                  return isValidSecretIdentityKey(k);
                })) {
                  _context2.next = 3;
                  break;
                }

                throw new Error('Some argument keys are not valid secret identity keys');

              case 3:
                params = secretIdKeys.map(function (k) {
                  return {
                    secret: k
                  };
                });
                _context2.next = 9;
                break;

              case 6:
                if (isValidSecretIdentityKey(secretIdKeys)) {
                  _context2.next = 8;
                  break;
                }

                throw new 'Argument is not a valid secret identity key.'();

              case 8:
                params = [{
                  secret: secretIdKeys
                }];

              case 9:
                _context2.next = 11;
                return this.cli.call('import-identity-keys', {
                  keys: params
                });

              case 11:
                _ref2 = _context2.sent;
                keys = _ref2.keys;
                return _context2.abrupt("return", keys);

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function importIdentityKeys(_x2) {
        return _importIdentityKeys.apply(this, arguments);
      }

      return importIdentityKeys;
    }()
    /**
     * Remove from walletd some identity keys.
     * @param {string|string[]} idKeys
     */

  }, {
    key: "removeIdentityKeys",
    value: function () {
      var _removeIdentityKeys = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(idKeys) {
        var _this = this;

        var publicIdKeys;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                publicIdKeys = [];

                if (!Array.isArray(idKeys)) {
                  _context3.next = 7;
                  break;
                }

                if (idKeys.every(function (k) {
                  return isValidIdentityKey(k);
                })) {
                  _context3.next = 4;
                  break;
                }

                throw new Error('Some argument identity keys are not valid');

              case 4:
                publicIdKeys = idKeys.map(function (k) {
                  return getPublicIdentityKey(k);
                });
                _context3.next = 10;
                break;

              case 7:
                if (isValidIdentityKey(idKeys)) {
                  _context3.next = 9;
                  break;
                }

                throw new Error('Argument is not a valid identity key.');

              case 9:
                publicIdKeys = [getPublicIdentityKey(idKeys)];

              case 10:
                _context3.next = 12;
                return Promise.all(publicIdKeys.map(function (key) {
                  return _this.cli.call('remove-identity-key', {
                    public: key
                  });
                }));

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function removeIdentityKeys(_x3) {
        return _removeIdentityKeys.apply(this, arguments);
      }

      return removeIdentityKeys;
    }()
    /**
     * Get all identity keys stored in walletd.
     * @async
     * @returns {{public: string, secret: string}[]}
     */

  }, {
    key: "getAllIdentityKeys",
    value: function () {
      var _getAllIdentityKeys = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var _ref3, keys;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.cli.call('all-identity-keys');

              case 2:
                _ref3 = _context4.sent;
                keys = _ref3.keys;
                return _context4.abrupt("return", keys ? keys : []);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getAllIdentityKeys() {
        return _getAllIdentityKeys.apply(this, arguments);
      }

      return getAllIdentityKeys;
    }()
    /**
     * Generates a new identity key from the wallet seed and stores it into walletd.
     * New keys are generated from the same mnemonic seed used for FCT and EC addresses.
     * @async
     * @param {number} [number=1] - Number of identity keys to generate.
     * @returns {{public: string, secret: string}}
     */

  }, {
    key: "generateIdentityKey",
    value: function () {
      var _generateIdentityKey = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5(number) {
        var nb, keys, i;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                nb = number || 1;

                if (!(typeof nb !== 'number' || nb < 1)) {
                  _context5.next = 3;
                  break;
                }

                throw new Error("Invalid number of identity keys to generate: ".concat(nb));

              case 3:
                keys = [];
                i = 0;

              case 5:
                if (!(i < nb)) {
                  _context5.next = 14;
                  break;
                }

                _context5.t0 = keys;
                _context5.next = 9;
                return this.cli.call('generate-identity-key');

              case 9:
                _context5.t1 = _context5.sent;

                _context5.t0.push.call(_context5.t0, _context5.t1);

              case 11:
                ++i;
                _context5.next = 5;
                break;

              case 14:
                return _context5.abrupt("return", keys);

              case 15:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function generateIdentityKey(_x4) {
        return _generateIdentityKey.apply(this, arguments);
      }

      return generateIdentityKey;
    }()
  }]);

  return FactomWalletdKeyStore;
}();

module.exports = FactomWalletdKeyStore;